import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-primary-900">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-primary-800 flex items-center justify-center mx-auto mb-6">
            <i className="ri-shield-check-line w-8 h-8 flex items-center justify-center text-primary-400 text-2xl" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('trust_title')}
          </h2>
          <p className="text-primary-200 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-8">
            {t('trust_desc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/safety/"
              className="px-6 py-3 bg-white text-primary-700 text-sm font-semibold rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              {t('safety_cta')}
            </a>
            <a
              href="/disclaimer/"
              className="px-6 py-3 bg-primary-800 text-primary-200 text-sm font-semibold rounded-lg hover:bg-primary-700 transition-colors whitespace-nowrap"
            >
              {t('footer_disclaimer')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}